/**
 * Semantic status badge.
 *
 * Wraps MUI <Chip /> with the design-system palette and a consistent
 * rounded-pill look. Use anywhere a status needs to be conveyed at a
 * glance: "Completed", "Overdue", "Due soon", "Preschool Age", etc.
 *
 *   <StatusBadge severity="success">Completed</StatusBadge>
 *   <StatusBadge severity="warning" dot>Due soon</StatusBadge>
 */
import React from "react";
import Chip from "@mui/material/Chip";
import "./StatusBadge.css";

const SEVERITY_CLASS = {
    success: "pt-badge--success",
    warning: "pt-badge--warning",
    danger: "pt-badge--danger",
    info: "pt-badge--info",
    neutral: "pt-badge--neutral",
    primary: "pt-badge--info",
    error: "pt-badge--danger",
};

export function StatusBadge({
    severity = "neutral",
    children,
    label,
    dot = false,
    size = "small",
    variant = "filled",
    className = "",
    ...rest
}) {
    const text = label ?? children;
    const klass = SEVERITY_CLASS[severity] || SEVERITY_CLASS.neutral;
    return (
        <Chip
            label={
                dot ? (
                    <span className="pt-badge__dot-row">
                        <span className="pt-badge__dot" />
                        <span>{text}</span>
                    </span>
                ) : (
                    text
                )
            }
            size={size}
            variant={variant}
            className={`pt-badge ${klass} ${className}`}
            {...rest}
        />
    );
}

export default StatusBadge;
